import { cloneDeep } from 'lodash-es';
import { TcsEntityType } from 'src/graphql/generated/graphql.generated';

interface Entity {
  id: string;
  __typename: string;
}

type EntityRecord = Record<any, any> & Entity;

function isObject(obj: any): obj is object {
  const type = typeof obj;
  return obj != null && (type === 'function' || type === 'object');
}

function isEntity(val: any): val is Entity {
  if (val == null) {
    return false;
  }

  const idVal = val.id;
  if (idVal == null || typeof idVal !== 'string' || idVal.trim().length === 0) {
    return false;
  }

  const typenameVal = val.__typename;
  if (typenameVal == null || typeof typenameVal !== 'string' || typenameVal.trim().length === 0) {
    return false;
  }

  return typenameVal in TcsEntityType;
}

function _flattenEntities(obj: Record<any, any>): EntityRecord[] {
  const result: EntityRecord[] = [];
  let selfEntity = false;
  if (isEntity(obj)) {
    result.push(obj);
    selfEntity = true;
  }

  Object.keys(obj).reduce((flattened, key) => {
    const propVal = obj[key];
    if (propVal instanceof Array) {
      propVal.forEach((item) => {
        const flattenedItem = _flattenEntities(item);
        flattened.push(...flattenedItem);
      });
      if (isEntity(propVal[0])) {
        delete obj[key];
      }
    } else if (isObject(propVal)) {
      const innerFlat = _flattenEntities(propVal);
      flattened.push(...innerFlat);
      if (isEntity(propVal)) {
        delete obj[key];
      }
    }
    return flattened;
  }, result);
  return result;
}
export function flattenEntities(obj: Record<any, any>): EntityRecord[] {
  if (obj == null) {
    throw new Error('flattenEntities: parameter cannot be null');
  }
  return _flattenEntities(cloneDeep(obj));
}
